import {
  faChevronLeft,
  faHome,
  faLandmark,
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'found';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import styled from 'styled-components';
import { setCurrentAccount } from '../../account_helpers';
import { routes } from '../../routes';
import Spacer from '../Spacer';
import { AccountDropdown_accounts } from './__generated__/AccountDropdown_accounts.graphql';

const Account = styled.div`
  font-size: 15px;
  font-weight: 500;
  display: flex;
  padding: 13px 24px;
  border-radius: 0px;
  cursor: pointer;
  transition: all 0.1s;
  align-items: center;
  &:hover {
    background: #f7f7f9;
  }
`;

const NewAccountButton = styled.div`
  display: flex;
  color: #5c6ef8;
  font-weight: 500;
  font-size: 15px;
  align-items: center;
  padding: 13px 24px;
  border-radius: 0px;
  cursor: pointer;
  transition: all 0.1s;
  &:hover {
    background: #f7f7f9;
  }
`;

const Header = styled.div`
  display: flex;
  padding: 10px 18px;
  align-items: center;
`;

const BackButton = styled.div`
  padding: 9px 13px;
  background: #f2f2f5;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    background: #e4e4e8;
  }
  border-radius: 100%;
  font-size: 14px;
`;

const Title = styled.div`
  font-weight: 700;
`;

type Props = {
  accounts: AccountDropdown_accounts;
  onClose: () => void;
  onBack: () => void;
};

const AccountDropdown = React.forwardRef(
  ({ accounts, onClose, onBack }: Props, ref: any) => {
    const { router, match } = useRouter();
    return (
      <div ref={ref}>
        <Header>
          <BackButton onClick={onBack}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </BackButton>
          <Spacer horizontal spacing={2} />
          <Title>Teams</Title>
        </Header>
        {accounts.map((account) => (
          <>
            <Account
              key={account.id}
              onClick={() => {
                setCurrentAccount(account.id);
                router.replace(match.location.pathname);
                onClose();
              }}
            >
              <FontAwesomeIcon
                icon={account.userMembership.isDefault ? faHome : faLandmark}
                color='#9092C1'
              />
              <Spacer horizontal spacing={1} />
              {account.name}
            </Account>
          </>
        ))}
        <Spacer vertical spacing={1} />
        <NewAccountButton
          onClick={() => {
            router.push(routes.createAccount);
            onClose();
          }}
        >
          <FontAwesomeIcon icon={faPlus} color='#5C6EF8' />
          <Spacer horizontal spacing={1} />
          Create new team
        </NewAccountButton>
      </div>
    );
  }
);

export default createFragmentContainer(AccountDropdown, {
  accounts: graphql`
    fragment AccountDropdown_accounts on Account @relay(plural: true) {
      id
      name
      userMembership {
        isDefault
      }
    }
  `,
});
